export default __webpack_public_path__ + "static/media/logo-desktop.15e1cf9b.svg";